const style = {
  popup: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "#FFFFFF",
    borderRadius: "10px",
    border: "none",
    outline: "none",
    boxShadow: 24,
    padding: "10px 15px 10px",
  },
  buttonStyle: {
    marginTop: "30px",
    backgroundColor: "#043D90",
    borderRadius: 8,
    width: 176,
    height: 40,
    // marginLeft: "20%",
    // marginBottom: "20%",
  },
  typography: {
    color: "#8C8C8C",
    fontSize: "20px",
  },
  inputStyle: {
    height: 91,
    width: "100%",
  },
  cancelButton: {
    marginLeft: "200px",
    marginTop: "-35px",
  },
};

export default style;
